import { request } from './request';

// 获取资源库
export const getAssetsList = async (params = {}, options = {}) => {
    const data = await request.get('/v1/assets', params, options);

    return data;
};

// 获取 收藏
export const getFavoritesList = async (params = {}, options = {}) => {
    const data = await request.get('/v1/assets/favorites', params, options);

    return data;
};

// 获取 他人收藏列表
export const getOthersFavoritesList = async (params = {}, options = {}) => {
    const data = await request.get('/v1/assets/others-favorites', params, options);

    return data;
};

// 批量取消收藏
export const batchRemove = async (params = {}, options = {}) => {
    const data = await request.post('/v1/assets/favorites/batch-remove', params, options);

    return data;
};

// 批量收藏
export const batchAdd = async (params = {}, options = {}) => {
    const data = await request.post('/v1/assets/favorites/batch-add', params, options);

    return data;
};

// 批量删除
export const batchDelete = async (params = {}, options = {}) => {
    const data = await request.post('/v1/assets/batch-delete', params, options);

    return data;
};

//  下载
export const assetsDownload = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.get(`/v1/assets/${id}/download`, {}, options);

    return data;
};
// 铸造
export const assetsSell = async (params = {}, options = {}) => {
    const { id, name } = params;
    const data = await request.post(`/v1/assets/${id}/sell`, { name }, options);

    return data;
};

// 铸造签名
export const batchMint = async (params = {}, options = {}) => {
    const data = await request.post(`/v1/assets/batch-mint`, params, options);

    return data;
};

export const assetsNfts = async (params = {}, options = {}) => {
    const data = await request.get(`/v1/assets/nfts`, params, options);

    return data;
};

export const taskDetails = async (params = {}, options = {}) => {
    const { id } = params;

    const data = await request.get(`/v1/assets/task/${id}`, {}, options);

    return data;
};
